import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const MARGIN_TOP = theme.spacing(4);
const HEIGHT_OF_ONE_ITEM = 48;
const HEIGHT_OF_HEADING = 32;

const containerStyle = css`
  display: flex;
  flex-direction: column;
  margin-top: ${MARGIN_TOP};
  flex: 1;
  overflow: hidden;
`;

interface GetContainerStyleConfig {
  numberOfItems: number;
}

export function getContainerStyle({ numberOfItems }: GetContainerStyleConfig) {
  if (numberOfItems === 1) {
    return [
      containerStyle,
      css`
        /* Show at least one item on screen */
        min-height: calc(${HEIGHT_OF_HEADING}px + ${HEIGHT_OF_ONE_ITEM}px);
      `,
    ];
  }

  return [
    containerStyle,
    css`
      /* Show at least two items on screen */
      min-height: calc(${HEIGHT_OF_HEADING}px + ${HEIGHT_OF_ONE_ITEM * 2}px);
    `,
  ];
}

export const listContainerStyle = css`
  margin-top: ${theme.spacing(1)};
  list-style: none;
  padding: 0;
  flex: 1;
  overflow: auto;
`;
